import React, { useState } from 'react';
import { Plus } from 'lucide-react';

interface TaskInputProps {
  onAddTask: (description: string) => void;
}

const TaskInput: React.FC<TaskInputProps> = ({ onAddTask }) => {
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedDescription = description.trim();
    
    if (trimmedDescription) {
      onAddTask(trimmedDescription);
      setDescription('');
    }
  };

  return (
    <div className="task-input-container">
      <form onSubmit={handleSubmit} className="task-form">
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="What needs to be done? ✨"
          className="task-input"
          maxLength={200}
        />
        <button
          type="submit"
          className="btn-add"
          disabled={!description.trim()}
        >
          <Plus size={20} />
          <span>Add Task</span>
        </button>
      </form>
      {description.length > 0 && (
        <p className="char-counter">
          {description.length}/200 characters
        </p>
      )}
    </div>
  );
};

export default TaskInput;